import { render, staticRenderFns } from "./BaseFloatingButton.vue?vue&type=template&id=6ba48b32&scoped=true&"
import script from "./BaseFloatingButton.vue?vue&type=script&lang=js&"
export * from "./BaseFloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseFloatingButton.vue?vue&type=style&index=0&id=6ba48b32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba48b32",
  null
  
)

export default component.exports